import React, { useState, useEffect } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import './UserHome.css'
import { BsCalendar3 } from 'react-icons/bs'
import { FaLayerGroup } from 'react-icons/fa'
import { MdToday } from 'react-icons/md'
import { ImUserCheck } from 'react-icons/im'
import { AiOutlineFileDone } from 'react-icons/ai'
import { TbFileAlert } from 'react-icons/tb'
import { Applications } from '../../components/UserHome/Applications/Applications'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdPendingActions,
} from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const UserHome = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  // fetch user,email from localstorage
  const user = localStorage.getItem('user')
  const id = localStorage.getItem('id')
  const token = localStorage.getItem('token')

  // to set total count,title,data, and title vise applications
  const [total, setTotal] = useState()
  const [title, setTitle] = useState('')
  const [data, setData] = useState()
  const [status, setStatus] = useState()
  const [today, setToday] = useState()
  const [pending, setpending] = useState()
  const [joined, setJoined] = useState()

  const [currentMonth, setCurrentMonth] = useState()
  const [inProgress, setInProgress] = useState()
  const [backward, setBackWard] = useState(true)
  const [forward, setForward] = useState(false)

  const [interviewStatus, setInterviewStatus] = useState(false)
  const [profiles, setProfiles] = useState([])

  // get all upcoming interviews of loggedin HR/Admin
  const getProfiles = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchInterviewerCandidates',

        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setProfiles(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // get and set  count and title for cards
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchTableData', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setTotal(response.data.totalApplications)
        setData(response.data.data)
        setTitle('Latest Applications')
      })
      .catch((error) => {
        setTotal(error.response.data.totalApplications)
        if (error.response.status === 401) {
          logout()
        }
      })

    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchConfirmedApplications', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setStatus(response.data.confirmedApplications)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })

    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchCurrentMonthApplications', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setCurrentMonth(response.data.currentMonthApplications)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })

    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchTodayApplications', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setToday(response.data.todayApplications)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })

    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchInProgressApplications', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setInProgress(response.data.InProgressApplications)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchPendingApplications', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setpending(response.data.PendingApplications)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchJoinedApplications', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setJoined(response.data.joinedApplications)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  // get and set table data and title on card click also set title in localstorage
  const getTableData = async (card) => {
    if (card === 1) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchTableData', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle('Latest Applications')
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            toast.error('Your Session Is Not Valid!!', {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 8000,
            })
            logout()
          }
        })
    } else if (card === 2) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchTodayApplications', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle("Today's Applications")
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            logout()
          }
        })
    } else if (card === 3) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchCurrentMonthApplications', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle('Current Month Applications')
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            logout()
          }
        })
    } else if (card === 4) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchConfirmedApplications', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle('Confirmed Applications')
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            logout()
          }
        })
    } else if (card === 5) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchInProgressApplications', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle('In Progress Applications')
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            logout()
          }
        })
    } else if (card === 6) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchPendingApplications', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle('Pending Applications')
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            logout()
          }
        })
    } else if (card === 7) {
      setInterviewStatus(false)
      await axios
        .get(Baseurl.nodeLocal + 'dashboard/fetchJoinedApplications', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setTitle('Joined Applications')
          setData(response.data.data)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            logout()
          }
        })
    }
  }

  return (
    <>
      <Sidebar />

      <div className="container ">
        <div className="userHome">
          <div className="d-flex justify-content-between">
            <h5 className="mt-5 mx-1">Welcome {user}!</h5>
            <button
              className="btn btn-outline-primary"
              type="button"
              style={{ height: '40px', marginTop: '2rem' }}
              onClick={() => {
                setInterviewStatus(true)
                setTimeout(() => {
                  getProfiles()
                }, 300)
              }}
            >
              View My Interviews
            </button>
          </div>
          <div className="row  p-1 mt-5 d-flex justify-content-between">
            {backward ? (
              <>
                <div
                  className="homecard col-md-4 col-12 card mt-2"
                  style={{
                    width: '15rem',
                    height: '10rem',
                    color: 'white',
                    backgroundColor: '#060D63',
                    cursor: 'pointer',
                  }}
                  onClick={() => getTableData(1)}
                >
                  <div className="card-body mt-2 row d-flex justify-content-center">
                    <div className="icon col-md-12 position-absolute">
                      <FaLayerGroup />
                    </div>
                    <div className="data row d-flex justify-content-center position-relative mt-5">
                      <h6
                        className="card-text col-md-12 d-flex justify-content-center"
                        style={{ fontSize: '1rem' }}
                      >
                        Total Applicants
                      </h6>
                      <p className="card-text col-md-12 d-flex justify-content-center">
                        {total}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="homecard col-md-4 col-12 card mt-2"
                  style={{
                    width: '15rem',
                    height: '10rem',
                    color: 'white',
                    backgroundColor: '#053B84',
                    cursor: 'pointer',
                  }}
                  onClick={() => getTableData(2)}
                >
                  <div className="card-body mt-2 row d-flex justify-content-center">
                    <div className="icon1 col-md-12 position-absolute">
                      <MdToday />
                    </div>
                    <div className="data row d-flex justify-content-center position-relative mt-5">
                      <h6
                        className="card-text col-md-12 d-flex justify-content-center"
                        style={{ fontSize: '1rem' }}
                      >
                        Today's Applications
                      </h6>
                      <p className="card-text col-md-12 d-flex justify-content-center">
                        {today}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="homecard col-md-4 col-12 card mt-2"
                  style={{
                    width: '15rem',
                    height: '10rem',
                    color: 'white',
                    backgroundColor: '#0D5EBE',
                    cursor: 'pointer',
                  }}
                  onClick={() => getTableData(3)}
                >
                  <div className="card-body mt-2 row d-flex justify-content-center ">
                    <div className="icon2 col-md-12 position-absolute">
                      <BsCalendar3 />
                    </div>

                    <div className="data row d-flex justify-content-center position-relative mt-5">
                      <h6
                        className="card-text text-center col-md d-flex justify-content-center"
                        style={{ fontSize: '1rem' }}
                      >
                        Current Month Applications
                      </h6>
                      <p className="card-text col-md-12 d-flex justify-content-center">
                        {currentMonth}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}

            <div
              className="homecard col-md-4 col-12 card mt-2"
              style={{
                width: '15rem',
                height: '10rem',
                color: 'white',
                backgroundColor: '#0E7AC6',
                cursor: 'pointer',
              }}
              onClick={() => getTableData(4)}
            >
              <div className="card-body mt-2 row d-flex justify-content-center">
                <div className="icon3 col-md-12 position-absolute">
                  <AiOutlineFileDone />
                </div>
                <div className="data row d-flex justify-content-center position-relative mt-5">
                  <h6
                    className="card-text text-center col-md-12 d-flex justify-content-center"
                    style={{ fontSize: '1rem' }}
                  >
                    Confirmed Applications
                  </h6>
                  <p className="card-text col-md-12 d-flex justify-content-center">
                    {status}
                  </p>
                </div>
              </div>
            </div>
            {forward ? (
              <>
                <div
                  className="homecard col-md-4 col-12 card mt-2"
                  style={{
                    width: '15rem',
                    height: '10rem',
                    color: 'white',
                    backgroundColor: '#11B1D7',

                    cursor: 'pointer',
                  }}
                  onClick={() => getTableData(5)}
                >
                  <div className="card-body mt-2 row d-flex justify-content-center">
                    <div className="icon4 col-md-12 position-absolute">
                      <MdPendingActions />
                    </div>
                    <div className="data row d-flex justify-content-center position-relative mt-5">
                      <h6
                        className="card-text col-md-12 d-flex justify-content-center text-center"
                        style={{ fontSize: '1rem' }}
                      >
                        In Progress <br />
                        Applications
                      </h6>
                      <p className="card-text col-md-12 d-flex justify-content-center">
                        {inProgress}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="homecard col-md-4 col-12 card mt-2"
                  style={{
                    width: '15rem',
                    height: '10rem',
                    color: 'white',
                    backgroundColor: '#12CCE0',
                    cursor: 'pointer',
                  }}
                  onClick={() => getTableData(6)}
                >
                  <div className="card-body mt-2 row d-flex justify-content-center">
                    <div className="icon5 col-md-12 position-absolute">
                      <TbFileAlert />
                    </div>
                    <div className="data row d-flex justify-content-center position-relative mt-5">
                      <h6
                        className="card-text col-md-12 d-flex justify-content-center text-center"
                        style={{ fontSize: '1rem' }}
                      >
                        Pending Applications
                      </h6>
                      <p className="card-text col-md-12 d-flex justify-content-center">
                        {pending}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="homecard col-md-4 col-12 card mt-2"
                  style={{
                    width: '15rem',
                    height: '10rem',
                    color: 'white',
                    backgroundColor: '#13E8E8',
                    cursor: 'pointer',
                  }}
                  onClick={() => getTableData(7)}
                >
                  <div className="card-body mt-2 row d-flex justify-content-center">
                    <div className="icon6 col-md-12 position-absolute">
                      <ImUserCheck />
                    </div>
                    <div className="data row d-flex justify-content-center position-relative mt-5">
                      <h6
                        className="card-text col-md-12 d-flex justify-content-center text-center"
                        style={{ fontSize: '1rem' }}
                      >
                        Joined Applications
                      </h6>
                      <p className="card-text col-md-12 d-flex justify-content-center">
                        {joined}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="row">
              <div className="d-flex justify-content-between mx-2">
                {backward ? (
                  <div style={{ cursor: 'pointer', color: '#C6EAF9' }}>
                    <MdArrowBackIos size={25} />
                  </div>
                ) : (
                  <div style={{ cursor: 'pointer', color: '#1a60f6' }}>
                    <MdArrowBackIos
                      size={25}
                      onClick={() => {
                        setBackWard(true)
                        setForward(false)
                      }}
                    />
                  </div>
                )}
                {forward ? (
                  <div style={{ cursor: 'pointer', color: '#C6EAF9' }}>
                    <MdArrowForwardIos size={25} />
                  </div>
                ) : (
                  <div style={{ cursor: 'pointer', color: '#1a60f6' }}>
                    <MdArrowForwardIos
                      size={25}
                      onClick={() => {
                        setBackWard(false)
                        setForward(true)
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Applications
          header={title}
          data={data}
          status={interviewStatus}
          profiles={profiles}
        />
      </div>
    </>
  )
}
